import { Typography } from '@sonnen/web-ui';
import { useTranslation } from '../../i18n/i18n';
import { DayAheadPriceConfiguration } from '../../types';
import { getTwoDigitsString } from '../../utils/formatting';
import { getDayAheadLabels } from '../../utils/utils';

export const DayAheadLabels = ({
  configuration,
  className,
}: {
  configuration?: DayAheadPriceConfiguration | null;
  className?: string;
}) => {
  const { firstYearPrice, priceAfterFirstYear } = getDayAheadLabels(configuration);
  const { t } = useTranslation();

  const firstYearPriceLabel =
    firstYearPrice > 0 ? getTwoDigitsString(firstYearPrice) : t('offer.freeTheFirstYear');

  return (
    <div className={className}>
      <span data-testid="price-after-first-year">
        <Typography.Label1 variant="secondary">
          <s>
            {priceAfterFirstYear} {t('chart.euroPerMonth')}
          </s>
        </Typography.Label1>
      </span>
      <br />
      <span data-testid="first-year-price">
        <Typography.Label1>{firstYearPriceLabel}</Typography.Label1>
      </span>
    </div>
  );
};
